// React i hooks

// API servisi



// Tipovi i konstante
import { SettingDetailPageCmp, SettingDetailPageProps } from "./types";
import { SETTING_DETAIL_PAGE_TITLE } from "ui/components/PageTitle/consts";
import { BreadcrumbItem } from "ui/components/Breadcrumb/types";
import { SIDEBAR_ITEM_SETTING } from "app/components/Sidebar/consts";

// UI komponente
import { Breadcrumb } from "ui/components/Breadcrumb";
import { PageHeader } from "ui/components/PageHeader";
import { PageTitle } from "ui/components/PageTitle";
import SettingDetailCard from "./components/SettingDetailCard/SettingDetailCard";
// import TabMenu from "../components/TabMenu/TabMenu";

// Moduli specifični za projekt
import { Routes } from "ui/modules/settings/navigation";
import TabMenu from "ui/modules/settings/pages/tenant/components/TabMenu/TabMenu";
import { getActiveUser } from "services/api/users";
import { useSelector } from "react-redux";


const SettingDetailPage: SettingDetailPageCmp = (
  props: SettingDetailPageProps
) => {
  const { user } = useSelector(getActiveUser);


  const title = SETTING_DETAIL_PAGE_TITLE;


  const breadcrumbs: BreadcrumbItem[] = [
    { text: SIDEBAR_ITEM_SETTING.text, route: SIDEBAR_ITEM_SETTING.route },
  ];

  if (!user) return <></>;

  return (
    <>
      <div className="">
        <div className="bg-white rounded-t-md">
          <PageHeader>
            <PageTitle
              title={`${title.text}`}
              icon={title.icon}
              iconColor={title.iconColor}
            />
            <Breadcrumb items={breadcrumbs} />
          </PageHeader>
          <TabMenu />
        </div>
        <div className="px-4 py-4">
          <SettingDetailCard  />
        </div>
      </div>
    </>
  );
};

SettingDetailPage.route = Routes.SettingDetailPageRouter;

export default SettingDetailPage;
